import './Bulbs.css';

import { connect } from 'react-redux';
import React from 'react';
//import { createSelector } from 'reselect';
import { pick } from 'lodash';

import bulbOff from './bulb-off.svg';
import bulbGoodLift from './bulb-good-lift.svg';
import bulbNoLift from './bulb-no-lift.svg';

const Bulbs = ({ refereeLights }) => {
  const { adjudications } = refereeLights;
  if (!adjudications.every($ => !!$)) return null;

  return (
    <div id="bulbs-container">
      <div id="bulbs">
        <div id="bulbs-inner">
          {adjudications.map((adjudication, index) => (
            <div key={index} id={`bulb${index}`} className="bulb">
              <span>{1 + index}</span>
              <img
                alt=""
                src={
                  adjudication === 'good-lift'
                    ? bulbGoodLift
                    : adjudication === 'no-lift'
                    ? bulbNoLift
                    : bulbOff
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ venue, orm }) => ({
  ...pick(venue.competition, 'refereeLights'),
});

export default connect(mapStateToProps)(Bulbs);



// WEBPACK FOOTER //
// ./src/components/Bulbs/Bulbs.js